<div class="holder">
  <h2 class="title">Insert a Link</h2>
  <input
    type="text"
    class="form-control"
    [(ngModel)]="link"
    placeholder="example: https://www.google.com" />

  <div class="buttons">
    <button class="btn" (click)="dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="close()">
      Done
    </button>
  </div>
</div>
